import { render, staticRenderFns } from "./ShipInformation.vue?vue&type=template&id=725c8744"
import script from "./ShipInformation.vue?vue&type=script&lang=ts"
export * from "./ShipInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports